import { useQuery } from '@tanstack/react-query';
import { GeoReportResponse } from '../../../models/geo-report/GeoReportResponse';
import { getGeoReports } from '../../../services/geo-report/GeoReportService';
import { GET_GEO_REPORTS } from '../../query/geo-report/keys';
import { useAccount } from '../../../contexts/account/AccountContexts';

export const useGetGeoReports = () => {
  const { accountResponse } = useAccount();
  const { data, isLoading, refetch } = useQuery<GeoReportResponse[]>({
    queryKey: [GET_GEO_REPORTS, accountResponse?.accountId],
    queryFn: () => getGeoReports(),
    staleTime: 1000 * 60 * 2,
    gcTime: 1000 * 60 * 10,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
  });

  return {
    data,
    isLoading,
    refetch,
  };
};